/* Receipt types returned by the API:
   SEF = scanned fiscal QR code, PEF = photo + NR. SERIK typed by the citizen,
   non_fiscal = photo of a receipt that wasn't printed by a fiscal device.
   Fields that don't apply to a receipt's type come back as null. */
export const RECEIPT_TYPES = { SEF: "SEF", PEF: "PEF", NON_FISCAL: "non_fiscal" };

export const isSefReceipt = (receipt) => receipt?.type === RECEIPT_TYPES.SEF;

/* SEF receipts are identified by the computed `branch_id-NUI-pos_id` device number,
   the others by the PEF serial number the citizen typed */
export const getDeviceNumber = (receipt) =>
  (isSefReceipt(receipt) ? receipt?.sef_device_number : receipt?.fiscal_device_number) || null;

/* Which receipt types count towards a game. The backend takes and returns `receipt_type`
   as a comma-separated set such as "PEF,SEF,non_fiscal"; games created before that may
   still hold the older "BOTH" (= SEF and PEF). */
export const GAME_RECEIPT_TYPE_OPTIONS = [
  { value: RECEIPT_TYPES.SEF, label: "SEF" },
  { value: RECEIPT_TYPES.PEF, label: "PEF" },
  { value: RECEIPT_TYPES.NON_FISCAL, label: "Jo fiskal" },
];

export const DEFAULT_GAME_RECEIPT_TYPES = [RECEIPT_TYPES.SEF, RECEIPT_TYPES.PEF];

export const parseGameReceiptTypes = (value) => {
  if (!value || value === "BOTH") return DEFAULT_GAME_RECEIPT_TYPES;
  return String(value).split(",").map((t) => t.trim()).filter(Boolean);
};

/* "SEF,PEF,non_fiscal" — only valid types, once each */
export const serializeGameReceiptTypes = (types = []) => {
  const set = new Set(types);
  return GAME_RECEIPT_TYPE_OPTIONS.map((o) => o.value).filter((t) => set.has(t)).join(",");
};

export const formatGameReceiptTypes = (value) =>
  parseGameReceiptTypes(value)
    .map((t) => GAME_RECEIPT_TYPE_OPTIONS.find((o) => o.value === t)?.label || t)
    .join(", ");
